// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IWorkHonestlySchema } from '../work_honestly/WorkHonestlySchema';

export interface IPublisherExtendedPropertiesSchema {
  /** Уровень брендирования **/
  brandingLevel?: EBrandingLevel;
  /** Сообщение об успешной проверке документов (в рамках 'Работаю честно') **/
  documentsCheckedLabel?: string;
  /** Параметры участия в программе `Работаю честно` **/
  workHonestly?: IWorkHonestlySchema;
}
export enum EBrandingLevel {
  'FirstLevel' = 'firstLevel',
  'SecondLevel' = 'secondLevel',
  'ThirdLevel' = 'thirdLevel',
}
